
   $("#header .cart-toggle-mini").click(function(e){
	e.preventDefault();
    console.log('open cart');
	$("body").addClass('drawer-is-open');
	$("#shopping-bag").addClass('show-bag');
  });
  $("#shopping-bag #close-minibag").click(function(e){
	$("#shopping-bag").removeClass('show-bag');
	$("body").removeClass('drawer-is-open');
  });
  function closeCart(){
	$("#shopping-bag").removeClass('show-bag');
	$("body").removeClass('drawer-is-open');
  }

   function productUpsellATC(product_id){
    console.log(product_id);
    const variantID = document.querySelector('#ks-cart-drawer-upsell-selector-'+product_id).value;
    console.log(variantID);
    //document.querySelector('#product-form-upsell-'+product_id+' a.btn-upsell').classList.add('btn--loading');
    let formData = {
    'items': [{
      'id': variantID,
      'quantity': 1
      }]
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      //return response.json();
      cart_load();
      $("body").addClass('drawer-is-open');
	  $("#shopping-bag").addClass('show-bag');
    })
    .catch((error) => {
      console.error('Error:', error);
    });

  }

  function addItemToMiniCart(id_variant,qty,open=true){
  	$.ajax({
    	type: 'POST',
    	url: '/cart/add.js',
    	data:    {quantity: qty, id: id_variant},
    	dataType: 'json',
    	error: addToCartFail,
    	success: function(e){
      	if(open){

			$("body").addClass('drawer-is-open');
        	$("#shopping-bag").addClass('show-bag');
        	cart_load();
        	//alert(1111);
        	$('#successDrawer').css('display','none');
        	$('#successDrawer').css('opacity','0');
        	e.preventDefault();

      	}
    	}
  	});

  }
  function editItemToMiniCart(id_variant,qty){
	var old_variant_id = jQuery('.editcart-btn').attr('data-variant');
	$.ajax({
  	type: 'POST',
  	url: '/cart/change.js',
  	data:    {quantity: 0, id: old_variant_id},
  	dataType: 'json',
  	error: addToCartFail,
  	success: function(){
    	addItemToMiniCart(id_variant,qty);
  	}
	});
  }
  function addToCartFail(jqXHR, textStatus, errorThrown){
	var response = $.parseJSON(jqXHR.responseText);
	//alert(response.description);
  }
  function removeItemInMiniCart(item_id){
	$.ajax({
  	type: 'POST',
  	url: '/cart/change.js',
  	data:  'quantity=0&id='+item_id,
  	dataType: 'json',
  	success: function(){
    	cart_load();
  	}
	});
  }
  function changeQuantityItemInMiniCart(item_id,qty){
	$.ajax({
  	type: 'POST',
  	url: '/cart/change.js',
  	data:  'quantity='+qty+'&id='+item_id,
  	dataType: 'json',
  	success: function(){
    	cart_load();
  	}
	});
  }
  function plusItemInMiniCart(item_id){
	console.log('qty plus');
	var currentVal = parseInt($('.qty-'+item_id).val());
	if (!isNaN(currentVal)) {
		$('.qty-'+item_id).val(currentVal + 1);
		changeQuantityItemInMiniCart(item_id,currentVal + 1);
	} else {
		$('.qty-'+item_id).val(1);
		changeQuantityItemInMiniCart(item_id,1);
	}
  }
  function minusItemInMiniCart(item_id){
	console.log('qty minus');
	var currentVal = parseInt($('.qty-'+item_id).val());
	if (!isNaN(currentVal) && currentVal > 1) {
		$('.qty-'+item_id).val(currentVal - 1);
		changeQuantityItemInMiniCart(item_id,currentVal - 1);
	} else {
		$('.qty-'+item_id).val(0);
		changeQuantityItemInMiniCart(item_id,0);
	}
  }
  function cart_load(){
	$.ajax({
  	type: 'GET',
  	url: '/cart?view=drawer',
  	success: function(data) {
    	$('#shopping-bag .sb-inner').html(data);
  	},
  	dataType: "html"
	});

	//update cart count number
	$.getJSON("/cart.js", function (results) {
  	if(results.item_count > 0){
    	$('.head-slot-cart-link-quantity').text(results.item_count).show();
  	}else{
    	$(".head-slot-cart-link-quantity").text('').hide();
  	}

	});
  }

  /*
	$('.qtyplus').click(function(e){
		console.log('qty plus');
		var item_id = $(this).attr('item-id');
		var currentVal = parseInt($(this).prev().val());
		if (!isNaN(currentVal)) {
		$(this).prev().val(currentVal + 1);
		changeQuantityItemInMiniCart(item_id,currentVal + 1);
		} else {
		$(this).prev().val(1);
		changeQuantityItemInMiniCart(item_id,1);
		}
	});
	$('.qtyminus').click(function(e){
		console.log('qty minus');
		var item_id = $(this).attr('item-id');
		var currentVal = parseInt($(this).next().val());
		if (!isNaN(currentVal) && currentVal > 1) {
		$(this).next().val(currentVal - 1);
		changeQuantityItemInMiniCart(item_id,currentVal - 1);
		} else {
		$(this).next().val(1);
		changeQuantityItemInMiniCart(item_id,1);
		}
	});
	*/
  $('#shopping-bag .coupon-code, #shopping-bag .sb-head, #shopping-bag .sb-checkout .subtotal-price, #shopping-bag .sb-product img, #shopping-bag .sb-detail .sb-title, #shopping-bag .sb-detail .sb-price').bind('touchend', function (evt) {
	closeMinicart();
  });
  $('#shopping-bag').bind('touchend', function (evt) {
	if(evt.target == $('#shopping-bag')[0]) {
  	closeMinicart();
	}
  });
  $('#shopping-bag .sb-detail').bind('touchend', function (evt) {
	if(evt.target == $('#shopping-bag .sb-detail')[0]) {
  	closeMinicart();
	}
  });
  $('#shopping-bag .sb-inner').bind('touchend', function (evt) {
	if(evt.target == $('#shopping-bag .sb-inner')[0]) {
  	closeMinicart();
	}
  });

  $(document).mouseup(function (e) {
    var $cartSideBar = $('#shopping-bag .sb-inner ');
    if (!$cartSideBar.is(e.target) && $cartSideBar.has(e.target).length === 0)
    {
      $('#shopping-bag').removeClass('show-bag');
	  $("body").removeClass('drawer-is-open');
    }
  });


// Custom style arrow loox widget
document.addEventListener("DOMContentLoaded", () => {
	setTimeout(() => {
  const looxWidget = document.querySelector('loox-snippets-widget');
  if (!looxWidget) return;
  const shadowRoot = looxWidget.shadowRoot;
  if (shadowRoot) {
    const arrowNode = shadowRoot.querySelectorAll('button.arrow');
    arrowNode.forEach((el) => {
      el.style.backgroundColor = '#FF4B01';
    });
  }
}, 2500);
})

